import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaTrashAlt, FaCopy } from "react-icons/fa";
import shortid from "shortid";
export class FieldDineInTables extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        value._id = shortid.generate();
        values.push(value);
        this.props.onChange(values);
    }
    remove(i) {
        const values = [...this.props.values];
        values.splice(i, 1);
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    render() {
        const { values, baseURL } = this.props;
        return (React.createElement("div", null, values.map((item, i) => {
            let url = "";
            if (item.name && item.password) {
                url =
                    baseURL +
                        `?table_id=${item._id}&table_pw=${item.password}`;
            }
            else if (item.name) {
                url = baseURL + `?table_id=${item._id}`;
            }
            return (React.createElement("div", { key: i, className: "flex-line", style: { alignItems: "flex-end" } },
                React.createElement(InputBox, { className: "no-round width64 text-center" },
                    React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Table Name" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", style: { width: "150px" }, value: item.name, onChange: (e) => this.change(i, "name", e.target.value) })),
                    React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Table Password" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", style: { width: "150px" }, value: item.password, onChange: (e) => this.change(i, "password", e.target.value) })),
                    React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Order URL" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", style: { width: "150px" }, value: url, readOnly: true, onFocus: (e) => e.target.select() }))),
                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                    React.createElement(FaTrashAlt, null)),
                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                    React.createElement(FaCopy, null))));
        })));
    }
}
//# sourceMappingURL=index.js.map